import React from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { useHistory, Link } from 'react-router-dom';
import moment from 'moment';
import { Breadcrumb, message, Tag } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import {
  ADD_ANNUAL_REPORT,
  ADD_ANNUAL_REPORT_WITH_CUSTOM_DATE,
  GET_ANNUAL_REPORTS,
} from 'gql/annualReports';
import { GET_CURRENT_REPORTING_PERIOD } from 'gql/reportingPeriod';
import { formatDatePickerValue } from 'utils';
import { useHasScopeType, useLoading } from 'hooks';
import AnnualReportForm from './components/AnnualReportForm';
import { DateDisplay } from 'components/layout';
import { GET_MY_CURRENT_USER_ROLE } from 'gql/auth';

const AddAnnualReport = () => {
  const history = useHistory();
  const { data } = useQuery(GET_CURRENT_REPORTING_PERIOD);
  const { data: dataMe } = useQuery(GET_MY_CURRENT_USER_ROLE);
  const { hasScopeType, loading: scopeLoading } = useHasScopeType(
    'WRITE_ANNUAL_REPORT_WITH_CUSTOM_DATE'
  );
  const [addAnnualReport, { loading: addLoading }] = useMutation(
    hasScopeType ? ADD_ANNUAL_REPORT_WITH_CUSTOM_DATE : ADD_ANNUAL_REPORT,
    {
      refetchQueries: [
        {
          query: GET_ANNUAL_REPORTS,
        },
      ],
      awaitRefetchQueries: true,

      onCompleted: () => {
        history.push('/annual-reports#reports');
        message.success(`Annual Report successfully submitted`);
      },
      onError: (err) => {
        console.log(err);
      },
    }
  );
  useLoading(addLoading);

  const onFinish = async ({
    actualSubmissionDate,
    faculty,
    projectCategory,
    attachment,
    remarks,
  }) => {
    const input = {
      projectCategory,
      attachment: attachment[0].id,
      remarks,
      reportingPeriod: data?.currentReportingPeriod?.id,
    };
    if (hasScopeType) {
      input.actualSubmissionDate = formatDatePickerValue(actualSubmissionDate);
      input.faculty = faculty;
    }
    await addAnnualReport({
      variables: {
        input,
      },
    });
    return true;
  };

  const initialValues = {
    actualSubmissionDate: new Date(),
    faculty: hasScopeType ? undefined : dataMe?.myCurrentUserRole?.faculty?.id,
  };
  const reportingPeriod = `${moment(
    data?.currentReportingPeriod?.startDate
  ).format('YYYY-MM-DD')}_${moment(
    data?.currentReportingPeriod?.endDate
  ).format('YYYY-MM-DD')}`;

  return (
    <div style={{ backgroundColor: '#fff', padding: '24px 0', width: '100%' }}>
      <PageContainer
        ghost
        header={{
          title: 'Add Reporting Period',
          breadcrumb: (
            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to="/annual-reports#reports">F/SLTC Annual Report</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Submit Annual Report</Breadcrumb.Item>
            </Breadcrumb>
          ),
        }}
        content={[
          <Tag
            key="currentReportingPeriod"
            color="#546e7a"
            style={{ fontSize: '16px', padding: '8px', marginTop: '-8px' }}
          >
            Current Reporting Period:{' '}
            <DateDisplay date={data?.currentReportingPeriod?.startDate} /> -{' '}
            <DateDisplay date={data?.currentReportingPeriod?.endDate} />
          </Tag>,
        ]}
      >
        <AnnualReportForm
          onFinish={onFinish}
          loading={scopeLoading}
          initialValues={initialValues}
          reportingPeriod={reportingPeriod}
          canCustomDate={hasScopeType}
        />
      </PageContainer>
    </div>
  );
};

export default AddAnnualReport;
